import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {wwData$} from './worker-data';
import type {Observable} from 'rxjs';

export const fundAccounts$: Observable<FundAccount[]> = wwData$.pipe(
  filter((o) => o.type === 'fund-accounts'),
  map((o) => o.data.accounts as FundAccount[]),
  startWith([]),
  shareReplay(1)
);

export const fundScaleAccounts$: Observable<FundAccount[]> = wwData$.pipe(
  filter((o) => o.type === 'fund-scale-accounts'),
  map((o) => o.data.accounts as FundAccount[]),
  startWith([]),
  shareReplay(1)
);
